module.exports = __webpack_public_path__ + "img/asian-specialities-1.f98b5332.jpg";